import styled, { css, keyframes } from 'styled-components';
import { useState } from 'react';

const Stretch = css`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;

export const Overlay = styled.div`
    ${Stretch}
    background: ${({ theme, staticOverlay }) =>
        staticOverlay || theme.overlay_white_linear};
    transition: ${({ theme }) => theme.slowLinear};
    pointer-events: none;
`;

const Container = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    opacity: 1;
    ${({ isDisabled }) =>
        isDisabled
            ? `
          opacity: .5;
          cursor: not-allowed;
          user-select: none;
          `
            : null}
`;

const Inner = styled.div`
    ${Stretch}
    box-shadow: ${({ theme }) => theme.box_shadow_1};
    border-radius: ${({ theme }) => theme.borderRadius_lg};
    overflow: hidden;
    background: ${({ theme }) => theme.overlay_black};
`;

export const HoverText = styled.div`
    opacity: 0;
    height: 0;
    width: 100%;
    overflow: hidden;
    transition: ${({ theme }) => theme.slowLinear};
`;

const fade = ({ theme }) => keyframes`
    from { background: ${theme.neutral_5}; }
    to { background: ${theme.neutral_6}; }
`;

const FadeAnimation = css`
    animation: ${(props) => fade(props)} 2s linear infinite alternate forwards;
`;

const ImageLoader = styled.div`
    background: ${({ theme }) => theme.neutral_5};
    ${Stretch}
    ${({ imageLoading }) => imageLoading && FadeAnimation}
`;

const BackgroundImage = styled.img`
    height: 100%;
    width: 100%;
    object-fit: cover;
    display: block;
    position: relative;
    filter: ${({ grayscale }) => (grayscale ? `grayscale(100%)` : `none`)};
`;

const StaticText = styled.div`
    border-bottom: solid 2px ${({ theme }) => theme.gray_7};
    width: 100%;
`;

const OverlayText = styled.div`
    ${Stretch}
    padding: ${({ theme, smallImage }) =>
        smallImage ? theme.space_4 : theme.space_8}px;
    display: flex;
    align-items: start;
    justify-content: flex-end;
    flex-direction: column;
`;

function Image({
    source,
    imageSize,
    hoverText = null,
    staticText = null,
    disabled,
    staticOverlay,
    ...restProps
}) {
    const [imageLoading, setImageLoading] = useState('loading');

    return (
        <Container isDisabled={!!disabled} {...restProps}>
            <Inner>
                <BackgroundImage
                    alt=""
                    src={source}
                    onLoad={() => setImageLoading('loaded')}
                    onError={() => setImageLoading('error')}
                />
                {imageLoading !== 'loaded' ? (
                    <ImageLoader imageLoading={imageLoading === 'loading'} />
                ) : null}
                {!disabled ? <Overlay staticOverlay={staticOverlay} /> : null}
                <OverlayText smallImage={imageSize === 'small'}>
                    {staticText ? <StaticText>{staticText}</StaticText> : null}
                    {hoverText ? <HoverText>{hoverText}</HoverText> : null}
                </OverlayText>
            </Inner>
        </Container>
    );
}

export default Image;
